import { Component, OnInit } from '@angular/core';
import { CommonFunctionService, UserPOSData} from '../../../../services/Common/common-function.service';
const _clone = (d) => JSON.parse(JSON.stringify(d));
import { environment } from '../../../../../environments/environment';
import { OrderTypeSetup } from 'src/app/POS/models/order-type-setup';
import * as CryptoJS from 'crypto-js';
import { Validators, FormControl } from "@angular/forms";
import { OrderService } from 'src/app/POS/POSServices/Setup/order.service';

// import { ListColumn } from './../../../core/list/list-column.model';
// import { ItemCategoryComponent } from './../item-category/item-category.component';
// import { DatePipe } from '@angular/common';

// import { ItemServiceService } from '../../../services/setup/item-service.service';

@Component({
  selector: 'app-order-type-lis',
  templateUrl: './order-type-lis.component.html',
  styleUrls: ['./order-type-lis.component.scss']
  //providers:[OrderService] ,
})
export class OrderTypeLisComponent implements OnInit {
  isreportsbtnActive: boolean = false;
  Range = [
    { text: "Today", value: "0" },
    { text: "Yesterday", value: "2" },
    { text: "current week", value: "4" },
    { text: "Last Week", value: "1" },
    { text: "This Month", value: "1" },
    { text: "Last Month", value: "2" },
    { text: "Custom Date Range", value: "4" }
  ];
  fromdate = new FormControl("", [Validators.required]);
  todate = new FormControl("", [Validators.required]);
  Fromdate1: any;
  todate1: any;
  isStartDateGreaterthenEndDate: boolean = false;
  Dfiltering:boolean = true;
  Rfromdate: boolean = false;
  isCustomDateSelected: boolean = false;
  daterange = new FormControl("", [Validators.required]);
  OrderType = new FormControl("", [Validators.required]);
  filtering:boolean=false;
  posid:any;

  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;
  listofordertype:any;
  InvoiceList: any[]; 
  PaidInvoicelist: any[]
  PendingInvoicelist: any[]
  tableHover = true;
  tableStriped = true;
  tableCondensed = true;
  tableBordered = true;
  resultsLength:any;

  // columns: ListColumn[] = [
  //   { name: 'Order Type', property: 'OrderType', visible: true, isModelProperty: true },
  //   { name: 'Default OrderType', property: 'DefaultOrderType', visible: true, isModelProperty: true },
  //   { name: 'Business Name', property:'PosSubscriptionId',visible:false,isModelProperty:true},
  //    { name: 'Notes', property: 'actions', visible: true },   
  // ] as ListColumn[];
  AlldataSource;
  PaidInvoicedataSource;
  PendingInvoicedataSource;
  posId: any;
  rows = [];
  temp = [];

  constructor(private service: OrderService, private commonfunction: CommonFunctionService) {

    let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
    this.posId= merchantdata.PosSubscriptionId;
        this.GetOrderTypeList((data) => {
          // cache our list
          this.temp = _clone(data);
          this.rows = _clone(data);
      });

    // this.service.GetOrderTypeList(merchantdata.PosSubscriptionId)
    // .subscribe(data => {     
    // this.AlldataSource = new MatTableDataSource<Employee>(data.map(result => new Employee(result)));
    // this.AlldataSource.paginator = this.paginator;
    // this.AlldataSource.sort = this.sort;
    // this.AlldataSource.columns = this.columns;
    // }); 


  }

  ngOnInit() {
  }
  // get visibleColumns() {
  //   return this.columns.filter(column => column.visible).map(column => column.property);
  // }
  
  GetOrderTypeList(cb) {
    const req = new XMLHttpRequest();
    this.listofordertype=localStorage.getItem('ordertypelist');
    // this.posid=localStorage.getItem('PosSubscriptionId')
    // let jsonObject: any  = JSON.parse(this.listofordertype);
    // let ordertypeerrespone: OrderTypeSetup = <OrderTypeSetup>jsonObject;
    if(this.listofordertype ==null)
    {
    req.open('GET',environment.GetOrderTypeListUrl + "?PosSubscriptionId=" +this.posId);
   
    req.onload = () => {
        cb(JSON.parse(req.response));
        // localStorage.setItem("ordertypelist",req.response);
        var encrypted = CryptoJS.AES.encrypt(req.response, "Secret Passphrase", {
          // format: JsonFormatter
        });
        localStorage.setItem("ordertypelist",encrypted);

    };

    req.send();
}
else{
//   if(ordertypeerrespone[0].posSubscriptionId==this.posId)
//   {
//   this.rows  = JSON.parse(localStorage.getItem('ordertypelist'));
// }
// else{
//   localStorage.removeItem('Customerlist');
//   window.location.reload();
// }
let  decrypteddata = localStorage.getItem('ordertypelist');
var decrypted = CryptoJS.AES.decrypt(decrypteddata, "Secret Passphrase", {
});

let data=decrypted.toString(CryptoJS.enc.Utf8);
if(data =="")
{
  localStorage.removeItem('ordertypelist');
  window.location.reload();
}
else
{
  this.rows=JSON.parse(data);
  if(this.rows.length !=0)
  {
    if(this.rows[0].posSubscriptionId==this.posId)
    {
         this.rows=JSON.parse(data);
     }
       else{
             this.rows=[];
              localStorage.removeItem('ordertypelist');
            window.location.reload();
     }

  }
  else
  {
    localStorage.removeItem('ordertypelist');
window.location.reload();
  }
}


}
}
clearcache()
  {
    localStorage.removeItem('ordertypelist');
    window.location.reload();
  }

  filters()
  {
    this.filtering = !this.filtering;
  }


  search() {
    this.GetOrdertypeFilrterData((data) => {
      this.temp = _clone(data);
      this.rows = _clone(data);;
    });
  }
  GetOrdertypeFilrterData(cb) {
    var daterange = this.daterange.value;
    var OrderType = this.OrderType.value;
  
    if (daterange == "Today") {

      this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);


    }
    else if (daterange == "Yesterday") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDate() - 1)).toISOString().slice(0, 10);
      this.Fromdate1 = tomorrow;
      this.todate1 = tomorrow;

    }
    else if (daterange == "current week") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDay()));


      var current = new Date();
      var weekstart = current.getDate() - current.getDay() + 1;
      var weekend = weekstart + 6;
      this.Fromdate1 = new Date(current.setDate(weekstart)).toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Week") {
      var curr = new Date;
      var first = curr.getDate() - curr.getDay() - 6;
      var last = first + 6;
      this.Fromdate1 = new Date(curr.setDate(first)).toISOString().slice(0, 10);
      this.todate1 = new Date(curr.setDate(last)).toISOString().slice(0, 10);


    }
    else if (daterange == "This Month") {
      const today = new Date();
      // const thismonth = new Date(today.setDate(today.getMonth())).toISOString().slice(0, 10);
      //this.Fromdate1=thismonth;   
      this.Fromdate1 = new Date(today.getFullYear(), today.getMonth(), 1).toDateString();
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Month") {
      // var date = new Date();                
      // this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0,10);
      // this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toISOString().slice(0,10);
      var date = new Date();
      this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toDateString();
      this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toDateString();


    }
    else if (daterange == "Custom Date Range") {

      this.Fromdate1 = this.fromdate.value;
      this.todate1 = this.todate.value;
    }
    else {
      this.Fromdate1 = '01/01/1990';
      this.todate1 ='01/01/1990';
    }
    let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
    const req = new XMLHttpRequest();
    req.open('GET',

      environment.FilteringOrderTypeDetails+"?PosSubscriptionId="+merchantdata.PosSubscriptionId+"&fromdate="+this.Fromdate1+"&todate="+this.todate1+"&OrderType="+ 
      OrderType);
    req.onload = () => {
      cb(JSON.parse(req.response));
    };
    req.send();
  }


  selectedaterange() {
    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;
    }
    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
     // this.search();

    }
  }
  checkDateRange() {
    if (this.fromdate.value != "" && this.todate.value != "") {
        if (this.fromdate.value > this.todate.value) {
            this.isreportsbtnActive = false;
            this.isStartDateGreaterthenEndDate = true;
        }
        else {
            this.isreportsbtnActive = true;
            this.isStartDateGreaterthenEndDate = false;
        }
    }
    else {
        this.isreportsbtnActive = false;
        this.isStartDateGreaterthenEndDate = false;
    }
  }
}




//   export class Employee {
  //     Id: any;
  //     // OrderType:any;
  //     OrderType:any;
  //     DefaultOrderType:any;
     
  //     constructor(res) {
  //       this.Id = res.id;
  //       this.OrderType = res.orderType;
  //       this.DefaultOrderType = res.defaultOrderType;
         
  //     }
  // }